import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import {
  FiltroBarra,
  FiltroCampo,
  FiltroLabel,
  FiltroSeparador,
} from './styled';

// Filtro de/ate por dias em atraso, entregue ao TableWrapper pela prop
// `filters` para ficar ao lado da busca. A faixa e avaliada sobre a parcela
// mais atrasada do contrato — quem faz essa conta e o useBillingList.
export default function DelayRangeFilter({
  from,
  to,
  onChangeFrom,
  onChangeTo,
  onClear,
}) {
  const ativo = from !== '' || to !== '';

  return (
    <FiltroBarra>
      <FiltroLabel>Dias em atraso</FiltroLabel>
      <FiltroCampo>
        <Input
          placeholder="De"
          holder
          small
          transparent
          type="number"
          value={from}
          onChange={(e) => onChangeFrom(e.target.value)}
        />
      </FiltroCampo>
      <FiltroSeparador>até</FiltroSeparador>
      <FiltroCampo>
        <Input
          placeholder="Até"
          holder
          small
          transparent
          type="number"
          value={to}
          onChange={(e) => onChangeTo(e.target.value)}
        />
      </FiltroCampo>
      {!ativo ? null : (
        <Button color="lightgrey" small nospace width="auto" onClick={onClear}>
          Limpar
        </Button>
      )}
    </FiltroBarra>
  );
}
